import { SegmentedControl } from 'cng-common/components/segmentedControl'

import { TMarketYoyGrowthExpectationRtm } from '../../../../api/types'

interface IRtmSegmentedControlProps {
  selectedRtm: TMarketYoyGrowthExpectationRtm
  onSelect: (rtm: TMarketYoyGrowthExpectationRtm) => void
  isDisabled: boolean
}

export const RtmSegmentedControl = ({
  selectedRtm,
  onSelect,
  isDisabled,
}: IRtmSegmentedControlProps) => (
  <SegmentedControl
    useItemKeys
    selectedItem={selectedRtm}
    isDisabled={isDisabled}
    onItemSelect={(key) => onSelect(key as TMarketYoyGrowthExpectationRtm)}
  >
    <SegmentedControl.Item itemKey="Reseller">
      <span>Reseller</span>
    </SegmentedControl.Item>
    <SegmentedControl.Item itemKey="Distributor">
      <span>Distributor</span>
    </SegmentedControl.Item>
  </SegmentedControl>
)

RtmSegmentedControl.displayName = 'RtmSegmentedControl'
